import monitoramentoApi from '../../api/monitoramento';
import * as types from '../mutation-types';
import latenize from '../../filters/latenize';

// initial state
const state = {
  all: {
    items: [],
    paginator: {},
    pasta: null,
  },
  termoPesquisado: '',
  pesquisa: {
    items: [],
    paginator: {},
  },
  item: {},
  origens: [],
  pastas: [],
  tribunalProcesso: null,
  diarioProcesso: null,
  referenciaProcesso: null,
  movimentacoes: {},
  cobertura: {},
  listaCobertura: [],
  filtroHelpCenter: '',
  sugestoes: {
    items: [],
    paginator: {},
  },
};

// getters
const getters = {
  coberturaFiltrada(state) {
      if (state.filtroHelpCenter) {
        const tipos = ['Tribunais', 'Diários Oficiais'];
        let filter = latenize(state.filtroHelpCenter);
        let filtered = {};
        for (let estado in state.cobertura) {
          if (latenize(estado).indexOf(filter) > -1) {
            filtered[estado] = {};
            Object.assign(filtered[estado], state.cobertura[estado]);
          } else {
            tipos.forEach(tipo => {
              if (!filtered[estado]) filtered[estado] = {};
              filtered[estado][tipo] = state.cobertura[estado][tipo].filter(t => {
                return latenize(t.nome).indexOf(filter) > -1 ||
                  latenize(t.sigla).indexOf(filter) > -1;
              });
              if (!filtered[estado][tipo].length) delete filtered[estado][tipo];
            })
          }
        }
        return filtered;
      }
      return state.cobertura;
  },
  diariosSelecionados(state) {
    if (state.origens.length) {
      return state.origens.reduce((b, a) => b + a.checked, 0);
    }
    return 0;
  },
  diariosDisponiveis(state) {
    if (state.origens.length) {
      return state.origens.reduce((b, a) => b + (a.diarios ? a.diarios.length : 0), 0);
    }
    return 0;
  },
};

// actions
const actions = {
  getMonitoramento({ commit }, id) {
    if (parseInt(id) !== parseInt(state.item.id)) {
      return monitoramentoApi.find(id)
        .then(({ data }) => {
          commit(types.SET_MONITORAMENTO, data.monitoramento);
        })
        .catch(({response}) => {
          commit(types.SET_MONITORAMENTO, response.data.monitoramento);
        });
    }
    return Promise.resolve(true);
  },
  /**
   * Lista de monitoramento do usuário
   *
   * @param commit
   * @param nextPage
   * @param pastaId
   * @returns {Promise<boolean>}
   */
  getMonitoramentos({ commit }, { nextPage, pastaId }) {
    // pega os monitoramentos de uma pasta
    // e é diferente da pasta aberta atualmente
    if (!nextPage && typeof pastaId !== 'undefined' && pastaId !== state.all.pasta) {
      return monitoramentoApi.all({ pastaId })
        .then(({ data }) => {
          commit(types.SET_MONITORAMENTOS, { data, pastaId });
        });
    }

    // se quero pegar a proxima pagina
    if (nextPage && typeof state.all.paginator.current_page !== 'undefined') {
      const page = state.all.paginator.current_page + 1;
      return monitoramentoApi.all({ page, pastaId })
        .then(({ data }) => {
          commit(types.PUSH_MONITORAMENTOS, { data, pastaId });
        });
    }

    // Faremos uma requisição apenas se os itens do cache foram alterados em algum momento
    // Ex: alteração de pasta do monitoramento
    if (state.all.pasta !== pastaId) {
      return monitoramentoApi.all()
        .then(({ data }) => {
          commit(types.SET_MONITORAMENTOS, { data, pastaId });
        });
    }

    return Promise.resolve(true);
  },
  getProcesso({ commit }, {forceReload, ...payload}) {
    if (forceReload === true || state.item.id !== parseInt(payload.id)) {
      // reseta as movimentacoes ao abrir a pagina de processos
      commit(types.RESET_MOVIMENTACOES);

      return monitoramentoApi.getProcesso(payload)
        .then(({ data }) => {
          commit(types.SET_MONITORAMENTO, data.monitoramento);
          commit(types.SET_PROCESSO, {tribunalProcesso: data.tribunal_processo, diarioProcesso: data.diario_processo, referenciaProcesso: data.referencia_processo});
        })
        .catch(({response}) => {
          commit(types.SET_MONITORAMENTO, response.data.monitoramento);
        });
    }
    return Promise.resolve(state.item);
  },
  getAparicoesMovimentacoesProcesso({ commit }, { forceReload, ...payload }) {
    const instancia = state.movimentacoes['DIARIO_TRIBUNAL'];

    if (forceReload === true || !instancia || (instancia && payload.page && payload.page !== instancia.paginator.current_page)) {
      return monitoramentoApi.getAparicoesMovimentacoesProcesso(payload)
        .then(({data}) => {
          if (forceReload === true) {
            commit(types.SET_MOVIMENTACOES, {movimentacoes: data, instanciaId: 'DIARIO_TRIBUNAL'});
          } else {
            commit(types.APPEND_MOVIMENTACOES, {movimentacoes: data, instanciaId: 'DIARIO_TRIBUNAL'});
          }
        })
    }
  },
  getAparicoesMovimentacoesTribunal({ commit }, { forceReload, ...payload }) {
    const instancia = state.movimentacoes[payload.instanciaId];

    if (forceReload === true || !instancia || (instancia && payload.page && payload.page !== instancia.paginator.current_page)) {
      return monitoramentoApi.getAparicoesMovimentacoesTribunal(payload)
        .then(({data}) => {
          if (forceReload === true) {
            commit(types.SET_MOVIMENTACOES, {movimentacoes: data, instanciaId: payload.instanciaId});
          } else {
            commit(types.APPEND_MOVIMENTACOES, {movimentacoes: data, instanciaId: payload.instanciaId});
          }
        })
    }
    return Promise.resolve();
  },
  getAparicoesMovimentacoesDiario({ commit }, { forceReload, ...payload }) {
    const instancia = state.movimentacoes[payload.instanciaId];

    if (forceReload === true || !instancia || (instancia && payload.page && payload.page !== instancia.paginator.current_page)) {
      return monitoramentoApi.getAparicoesMovimentacoesDiario(payload)
        .then(({data}) => {
          if (forceReload === true) {
            commit(types.SET_MOVIMENTACOES, {movimentacoes: data, instanciaId: payload.instanciaId});
          } else {
            commit(types.APPEND_MOVIMENTACOES, {movimentacoes: data, instanciaId: payload.instanciaId});
          }
        })
    }
    return Promise.resolve();
  },
  getReferenciasProcesso({ commit }, { forceReload, ...payload }) {
    const instancia = state.movimentacoes[payload.instanciaId];

    if (forceReload === true || !instancia || (instancia && payload.page && payload.page !== instancia.paginator.current_page)) {
      return monitoramentoApi.getReferenciasProcesso(payload)
        .then(({data}) => {
          if (forceReload === true) {
            commit(types.SET_MOVIMENTACOES, {movimentacoes: data, instanciaId: payload.instanciaId});
          } else {
            commit(types.APPEND_MOVIMENTACOES, {movimentacoes: data, instanciaId: payload.instanciaId});
          }
        })
    }

    return Promise.resolve();
  },
  marcarAparicoesTribunalInstanciaVisualizadas({ commit }, payload) {
    commit(types.VISUALIZAR_APARICOES_MONITORAMENTO, payload.monitoramentoId);
    return monitoramentoApi.marcarAparicoesTribunalInstanciaVisualizadas(payload);
  },
  marcarAparicoesTribunalVisualizadas({ commit }, payload) {
    commit(types.VISUALIZAR_APARICOES_MONITORAMENTO, payload.monitoramentoId);
    return monitoramentoApi.marcarAparicoesTribunalVisualizadas(payload);
  },
  marcarAparicoesDiarioVisualizadas({ commit }, payload) {
    commit(types.VISUALIZAR_APARICOES_MONITORAMENTO, payload.monitoramentoId);
    return monitoramentoApi.marcarAparicoesDiarioVisualizadas(payload);
  },
  excluirMonitoramentos({ commit }, monitoramento) {
    monitoramentoApi.destroy([monitoramento.id]);
    commit(types.RESET_MOVIMENTACOES);
    commit(types.EXCLUIR_MONITORAMENTOS, monitoramento);
    commit(types.RESETAR_APARICOES);
    commit(types.SET_ITENS_SELECIONADO, []);
  },
  moverMonitoramentos({ commit }, { monitoramento, pasta, find }) {
    return monitoramentoApi.mover(monitoramento.id, pasta.id)
      .then(({ data }) => {
        commit(types.MOVER_MONITORAMENTOS, { monitoramento, pasta, find });
        commit(types.ATUALIZAR_PASTA_EM_NOTIFICACOES, { monitoramentoId: monitoramento.id, pasta });
        commit(types.ABRIR_PASTA, pasta);
      });
  },
  removerMonitoramentoPasta({ commit }, monitoramento) {
    commit(types.REMOVER_MONITORAMENTO_PASTA, monitoramento);
    commit(types.ATUALIZAR_PASTA_EM_NOTIFICACOES, { monitoramentoId: monitoramento.id });
    return monitoramentoApi.removerDaPasta(monitoramento.id);
  },
  getPastasMonitoramento({ commit }) {
    if (!state.pastas.length) {
      monitoramentoApi.getPastas(({ items }) => {
        commit(types.SET_PASTAS_MONITORAMENTO, items);
      });
    }
  },
  criarPastaMonitoramento({ commit }, pasta) {
    return monitoramentoApi.criarPastaMonitoramento(pasta, (data) => {
      commit(types.CRIAR_PASTA_MONITORAMENTO, data);
      EventBus.$emit('modal-close');
    });
  },
  criarPastaMoverMonitoramento({ commit }, payload) {
    return monitoramentoApi.criarPastaMoverMonitoramento({
      pasta: payload.pastaNome,
      monitoramentoId: payload.monitoramento.id,
    })
      .then(({ data }) => {
        commit(types.CRIAR_PASTA_MONITORAMENTO, data);
        commit(types.MOVER_MONITORAMENTOS, { monitoramento: payload.monitoramento, pasta: data });
        commit(types.ATUALIZAR_PASTA_EM_NOTIFICACOES, { monitoramentoId: payload.monitoramento.id, pasta: data });
        commit(types.ABRIR_PASTA, data);
        EventBus.$emit('modal-close');
      });
  },
  editarPastaMonitoramento({ commit }, payload) {
    return monitoramentoApi.editarPastaMonitoramento(payload)
      .then(({ data }) => {
        commit(types.EDITAR_PASTA_MONITORAMENTO, data);
        EventBus.$emit('modal-close');
      });
  },
  excluirPastaMonitoramento({ commit }, payload) {
    return monitoramentoApi.excluirPastaMonitoramento({
      pastaId: payload.pastaId,
      excluirMonitoramentos: payload.excluirMonitoramentos,
    })
      .then(({ data }) => {
        commit(types.EXCLUIR_PASTA_MONITORAMENTO, {pastaId: payload.pastaId, excluirMonitoramentos: payload.excluirMonitoramentos});
        EventBus.$emit('modal-close');
      });
  },
  criarMonitoramento({ commit }, payload) {
    return monitoramentoApi.store(payload)
        .then(({ data }) => {
          data.monitoramento.new = true;
          commit(types.CRIAR_MONITORAMENTO, data.monitoramento);
          commit(types.SET_MONITORAMENTO, data.monitoramento);
          commit(types.SET_PROCESSO, { tribunalProcesso: data.tribunal_processo, diarioProcesso: data.diario_processo });
          return data.monitoramento;
        })
  },
  criarMonitoramentoSugestao({ commit }, payload) {
    return monitoramentoApi.store(payload)
        .then(({ data }) => {
          commit(types.CRIAR_MONITORAMENTO, data.monitoramento);
          return data.monitoramento;
        })
  },
  editarMonitoramento({ commit }, payload) {
    return monitoramentoApi.edit(payload.form, (data) => {
      commit(types.EDITAR_MONITORAMENTO, {
        monitoramento: payload.monitoramento,
        newMonitoramento: data.monitoramento,
      });
      EventBus.$emit('modal-close');
    });
  },
  getOrigens({ commit }) {
    if (state.origens.length === 0) {
      return monitoramentoApi.getOrigens()
        .then(({ data }) => {
          commit(types.SET_ORIGENS, data);
        });
    }
    return Promise.resolve('success');
  },
  getCobertura({ commit }) {
    if (Object.keys(state.cobertura).length === 0) {
      monitoramentoApi.getCobertura()
        .then(({ data }) => {
          commit(types.SET_COBERTURA, data.data);
        });
    }
    return Promise.resolve('success');
  },
  pesquisarMonitoramentos({ commit }, payload) {
    return monitoramentoApi.pesquisarMonitoramentos(payload)
      .then(({ data }) => {
        commit(types.UPDATE_SEARCH_RESULTS, data);
      });
  },
  consultarStatusAtivacaoProcessoTribunal({ commit }, payload) {
    return monitoramentoApi.consultarStatusAtivacaoProcessoTribunal(payload)
      .then(({data}) => {
        // commit(types.SET_PESQUISA_PROCESSO, data);
        return data;
      });
  },
  marcarReferenciaVisualizada({ commit }, aparicao) {
    commit(types.VISUALIZAR_REFERENCIAS_PROCESSO, aparicao.id);
  },
  marcarReferenciasNaoVisualizadas({ commit }, aparicao) {
    commit(types.MARCAR_REFERENCIAS_NAO_VISUALIZADAS, aparicao.id);
  },
  excluirReferencias({ commit }, aparicoes) {
    commit(types.EXCLUIR_REFERENCIAS_PROCESSO, aparicoes);
  },
  getQuantidadeAparicoesNaoVisualizadas({ commit }, payload) {
    return monitoramentoApi.getQuantidadeAparicoesNaoVisualizadas(payload)
      .then(({data}) => {
        commit(types.SET_QUANTIDADE_APARICOES_NAO_VISUALIZADAS, {quantidade_aparicoes_nao_visualizadas_por_tipo: data.quantidade_aparicoes_nao_visualizadas_por_tipo});
      })
  },
  getSugestoesDoMonitoramento({ commit }, payload) {
    return monitoramentoApi.getSugestoesDoMonitoramento(payload)
      .then(({data}) => {
        if (parseInt(payload.page) > 1) {
          commit(types.LOADMORE_SUGESTOES_MONITORAMENTO, data);
        } else {
          commit(types.SET_SUGESTOES_MONITORAMENTO, data);
        }
      })
  },
};

// mutations
const mutations = {
  [types.SET_MONITORAMENTOS](state, { data, pastaId }) {
    const monitoramentos = data;
    state.all.items = monitoramentos.items;
    state.all.paginator = monitoramentos.paginator;
    state.all.pasta = pastaId;
  },
  [types.PUSH_MONITORAMENTOS](state, { data, pastaId }) {
    const monitoramentos = data;
    state.all.items = state.all.items.concat(monitoramentos.items);
    state.all.paginator = monitoramentos.paginator;
    state.all.pasta = pastaId;
  },
  [types.SET_COBERTURA](state, cobertura) {
    state.cobertura = cobertura;
  },
  [types.UPDATE_FILTRO_HELPCENTER](state, filtro) {
    state.filtroHelpCenter = filtro;
  },
  [types.SET_MONITORAMENTO](state, monitoramento) {
    state.item = monitoramento;
    // state.tribunalProcesso = {};
  },
  [types.UPDATE_MONITORAMENTO](state, monitoramento) {
    const index = state.all.items.findIndex(m => m.id === monitoramento.id);
    if (typeof index !== 'undefined') {
      state.all.items.splice(index, 1, monitoramento);
    }
  },
  [types.SET_PROCESSO](state, { tribunalProcesso, diarioProcesso, referenciaProcesso }) {
    state.tribunalProcesso = tribunalProcesso;
    state.diarioProcesso = diarioProcesso;
    state.referenciaProcesso = referenciaProcesso;
  },
  [types.SET_MOVIMENTACOES](state, { movimentacoes, instanciaId }) {
    Vue.set(state.movimentacoes, instanciaId, movimentacoes);
  },
  [types.APPEND_MOVIMENTACOES](state, { movimentacoes, instanciaId }) {
    // se ja tiver movimentacoes dessa instancia, vamos dar append
    if (state.movimentacoes[instanciaId]) {
      state.movimentacoes[instanciaId].paginator = movimentacoes.paginator;
      state.movimentacoes[instanciaId].links = movimentacoes.links;
      state.movimentacoes[instanciaId].items.splice(state.movimentacoes[instanciaId].items.length, 0, ...movimentacoes.items);
    } else {
      Vue.set(state.movimentacoes, instanciaId, movimentacoes);
    }
  },
  [types.RESET_MOVIMENTACOES](state) {
    state.movimentacoes = {};
  },
  [types.CRIAR_MONITORAMENTO](state, monitoramento) {
    state.all.items.unshift(monitoramento);
  },
  [types.EDITAR_MONITORAMENTO](state, { monitoramento, newMonitoramento }) {
    state.item = newMonitoramento;
    // Verificamos se o monitoramneto está na listagem de Todos os monitoramentos
    const i = state.all.items.findIndex((m) => m.id === monitoramento.id);
    if (typeof i !== "undefined") {
      state.all.items.splice(i, 1, newMonitoramento);
    }
  },
  [types.SET_PASTAS_MONITORAMENTO](state, pastas) {
    pastas.forEach((p) => { p.open = false; });
    state.pastas = pastas;
  },
  [types.CRIAR_PASTA_MONITORAMENTO](state, pasta) {
    pasta.new = true;
    pasta.open = false;
    state.pastas.unshift(pasta);
  },
  [types.EDITAR_PASTA_MONITORAMENTO](state, pasta) {
    state.pastas.forEach(p => {
      if (p.id === pasta.id) {
        p.nome = pasta.nome;
      }
    });
  },
  [types.EXCLUIR_PASTA_MONITORAMENTO](state, {pastaId, excluirMonitoramentos}) {
    if(excluirMonitoramentos) {
      // remover os monitoramentos que eram dessa pasta
      state.all.items = state.all.items.filter(m => m.pasta_id !== pastaId);
    } else {
      // remove a pasta da lista de pastas
      state.pastas = state.pastas.filter(p => p.id !== pastaId);

      // remover os monitoramentos de dentro da pasta
      state.all.items = state.all.items.map((m) => {
        if(m.pasta_id === pastaId) {
          m.pasta = null;
          m.pasta_id = null;
        }
        return m;
      });
    }
  },
  [types.UPDATE_MONITORAMENTOS](state, monitoramentos) {
    state.all = monitoramentos;
  },
  [types.TOGGLE_PASTA](state, pasta) {
    pasta.open = !pasta.open;
  },
  [types.ABRIR_PASTA](state, pasta) {
    pasta.open = true;
  },
  [types.FECHAR_PASTA](state, pasta) {
    pasta.open = false;
  },
  [types.SET_ORIGENS](state, origens) {
    state.origens = origens;
  },
  [types.CHECK_ALL_ORIGENS](state) {
    let select = true;
    if (getters.diariosSelecionados(state) > 0) {
      select = false;
    }
    state.origens.forEach((o) => {
      o.checked = select ? o.diarios.length : 0;
      o.diarios.forEach((d) => {
        d.selected = select;
      });
    });
  },
  [types.TOGGLE_DIARIO](state, { origem, diario }) {
    if (diario.selected) {
      diario.selected = false;
      origem.checked -= 1;
    } else {
      diario.selected = true;
      origem.checked += 1;
    }
  },
  [types.ATUALIZAR_NOTIFICACOES_NAO_VISUALIZADAS](state, { pastaId, monitoramentoId, incrementar }) {
    const pasta = state.pastas.find(p => p.id === pastaId);
    if (typeof pasta !== 'undefined') {
      if (incrementar) pasta.aparicoes_nao_visualizadas += 1;
      else pasta.aparicoes_nao_visualizadas -= 1;
    } else {
      const monitoramento = state.all.items.find(m => m.id === monitoramentoId);
      if (typeof monitoramento !== 'undefined') {
        if (incrementar) monitoramento.aparicoes_nao_visualizadas += 1;
        else monitoramento.aparicoes_nao_visualizadas -= 1;
      }
    }
  },
  [types.RESET_DIARIOS](state) {
    if (state.origens.length > 0) {
      state.origens.forEach((o) => {
        o.show = false;
        o.selected = o.nome === 'Tribunais Superiores';
        o.checked = o.nome === 'Tribunais Superiores' ? o.diarios.length : 0;
        if (o.nome !== 'Tribunais Superiores') {
          o.diarios.forEach((d) => {
            d.checked = false;
            d.selected = false;
          });
        }
      });
    }
  },
  [types.TOGGLE_ORIGEM](state, origem) {
    if (origem.checked !== 0) {
      origem.diarios.forEach((d) => {
        d.selected = false;
      });
      origem.checked = 0;
    } else {
      origem.diarios.forEach((d) => {
        d.selected = !d.selected;
      });
      origem.checked = origem.diarios.length;
    }
  },
  [types.OPEN_ORIGEM](state, origem) {
    origem.show = !origem.show;
  },
  [types.EXCLUIR_MONITORAMENTOS](state, monitoramento) {
    state.all.items = state.all.items.filter(m => m.id !== monitoramento.id);
    state.pesquisa.items = state.pesquisa.items.filter(m => m.id !== monitoramento.id);
  },
  [types.MOVER_MONITORAMENTOS](state, { monitoramento, pasta, find }) {
    // Se o monitoramento possuia pasta, precisamos remover ele da pasta antiga.
    if (monitoramento.pasta_id) {
      const oldPasta = state.pastas.find(p => p.id === monitoramento.pasta_id);
      oldPasta.aparicoes_nao_visualizadas -= monitoramento.aparicoes_nao_visualizadas;
    }
    monitoramento.pasta_id = pasta.id;
    monitoramento.pasta = pasta;
    if (typeof find !== 'undefined') {
      const newPasta = state.pastas.find(p => p.id === pasta.id);
      newPasta.aparicoes_nao_visualizadas += monitoramento.aparicoes_nao_visualizadas;
      return;
    }
    pasta.aparicoes_nao_visualizadas = monitoramento.aparicoes_nao_visualizadas;
  },
  [types.REMOVER_MONITORAMENTO_PASTA](state, monitoramento) {
    // Primeiro removemos o monitoramento da pasta
    const pasta = state.pastas.find(p => p.id === monitoramento.pasta_id);
    if (typeof pasta !== 'undefined') {
      // Diminuimos o número de aparições da pasta;
      pasta.aparicoes_nao_visualizadas -= monitoramento.aparicoes_nao_visualizadas;
    }
    // Agora setamos a pasta como null no objeto do monitoramento
    monitoramento.pasta_id = null;
    monitoramento.pasta = null;
  },
  [types.VISUALIZAR_APARICOES_MONITORAMENTO] (state, monitoramentoId) {
    state.item.aparicoes_nao_visualizadas = 0;
    const monitoramento = state.all.items.find(m => m.id === parseInt(monitoramentoId));
    if (monitoramento) monitoramento.aparicoes_nao_visualizadas = 0;
  },
  [types.ATUALIZAR_STATUS_SUGESTAO] (state, {sugestaoId, status}) {
    state.sugestoes.items.find(s => s.id === sugestaoId).status = status;
  },
  [types.UPDATE_SEARCH_TERM] (state, searchTerm) {
    state.termoPesquisado = searchTerm;
  },
  [types.UPDATE_SEARCH_RESULTS] (state, searchResults) {
    state.pesquisa.items = searchResults.items;
    state.pesquisa.paginator = searchResults.paginator;
  },
  [types.VISUALIZAR_REFERENCIAS_PROCESSO] (state, aparicaoId) {
    let item = state.movimentacoes['REFERENCIAS'].items.find(a => a.id === aparicaoId);
    // let item = state.referencias.items.find(a => a.id === aparicaoId);
    if (item && !item.bloqueado) {
      item.visualizado = 'SIM';
    }
  },
  [types.MARCAR_REFERENCIAS_NAO_VISUALIZADAS] (state, aparicaoId) {
    let item = state.movimentacoes['REFERENCIAS'].items.find(a => a.id === aparicaoId);
    // let item = state.referencias.items.find(a => a.id === aparicaoId);
    if (item) {
      item.visualizado = 'NAO';
    }
  },
  [types.EXCLUIR_REFERENCIAS_PROCESSO] (state, aparicoes) {
    state.movimentacoes['REFERENCIAS'].items = state.movimentacoes['REFERENCIAS'].items.filter(a => aparicoes.indexOf(a.id) === -1);
  },
  [types.SET_QUANTIDADE_APARICOES_NAO_VISUALIZADAS] (state, {quantidade_aparicoes_nao_visualizadas_por_tipo}) {
    state.item.quantidade_aparicoes_nao_visualizadas_por_tipo = quantidade_aparicoes_nao_visualizadas_por_tipo;
  },
  [types.SET_SUGESTOES_MONITORAMENTO] (state, sugestoes) {
    state.sugestoes = sugestoes;
  },
  [types.LOADMORE_SUGESTOES_MONITORAMENTO] (state, sugestoes) {
    state.sugestoes = {
      ...sugestoes,
      items: [...state.sugestoes.items, ...sugestoes.items]
    };
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
